export default __webpack_public_path__ + "img/07db7ec7ce4dd0523acfe3b00a76f7b0.svg";